import * as React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";
import { getHomepage } from "utils";
import { useTranslate } from "hooks";
import type { ObjValidatorProps } from "interfaces/shared.types";

const ErrorPage = Scrivito.connect(({ page }: ObjValidatorProps) => {
  const translate = useTranslate();
  const homepage = getHomepage() as Scrivito.Obj;
  const welcomePage = homepage.get("welcomePage") as Scrivito.Obj;

  const goBack = () => {
    window.history.go(-2);
    // if redirect didn't occurre (in case when user has a link to the project which is deleted)
    Scrivito.navigateTo(welcomePage ?? homepage);
  };

  if (!page) {
    return null;
  }

  return (
    <div className="bg-white col-md-6 mx-auto px-2 py-10 text-center">
      <Scrivito.ContentTag tag="h3" content={page} attribute="title">
        {translate("ERROR_PAGE_NOT_FOUND_TITLE")}
      </Scrivito.ContentTag>
      <Scrivito.ContentTag tag="p" content={page} attribute="subtitle">
        {translate("ERROR_PAGE_NOT_FOUND_TEXT")}
      </Scrivito.ContentTag>
      <div className="d-flex gap-4 justify-content-center">
        <Scrivito.LinkTag
          data-testid="ErrorPageComponent_back-link"
          className="btn btn-primary"
          onClick={goBack}
        >
          {translate("BACK")}
        </Scrivito.LinkTag>
      </div>
    </div>
  );
});

const CheckedPage = (props: ObjValidatorProps) => (
  <ObjValidator {...props}>
    <ErrorPage {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ErrorPage", CheckedPage);
